module.exports = __webpack_public_path__ + "img/ic_winner_ticket_notification.9af3a46d.png";